import {
    Component,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    ViewContainerRef,
    OnDestroy,
    TemplateRef,
    OnInit,
    ChangeDetectorRef,
    Input,
} from '@angular/core';
import { ContextBarService } from './context-bar.service';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { TemplatePortal } from '@angular/cdk/portal';
import { isNullOrUndefined } from '@core/utils/object';
import { Subject } from 'rxjs';

/**
 * Context Bar Component.
 */
@Component({
    selector: 'pay-context-bar',
    templateUrl: './context-bar.component.html',
    styleUrls: ['./context-bar.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-context-bar',
    },
})
export class ContextBarComponent implements OnInit, OnDestroy {
    @Input() isDynamic: boolean = false;

    public mainPortal: TemplatePortal;
    public actionsPortal: TemplatePortal;
    public dynamicPortalData: any;

    private destroyed$: Subject<void> = new Subject();

    constructor(
        private contextBarService: ContextBarService,
        private viewContainerRef: ViewContainerRef,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.contextBarService
            .getMainContents()
            .pipe(
                takeUntil(this.destroyed$),
                filter(
                    (template: TemplateRef<any>) => !isNullOrUndefined(template)
                )
            )
            .subscribe((template: TemplateRef<any>) => {
                this.mainPortal = new TemplatePortal(template, null);
                this.cdr.detectChanges();
            });

        this.contextBarService
            .getActionContents()
            .pipe(
                takeUntil(this.destroyed$),
                filter(
                    (template: TemplateRef<any>) => !isNullOrUndefined(template)
                )
            )
            .subscribe((template: TemplateRef<any>) => {
                this.actionsPortal = new TemplatePortal(template, null);
                this.cdr.detectChanges();
            });
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
        this.viewContainerRef.clear();
    }
}
